import { writable } from 'svelte/store';
export const post = writable(null);
export const isSuccessLoading = writable(false);
